import KeyPersonApiClient from "@/api/keyPersonApiClient";
import { AppToasterV2 } from "@ucl/library";
import { useEffect, useState } from "react";
import { useAuthenticatedApiClient } from "./useAuthenticatedApiClient";
import { KeyPerson } from "@/types/KeyPerson";

export const useKeyPeopleSummary = (financialApplicationId: string) => {
  const [keyPeople, setKeyPeople] = useState<KeyPerson[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const keyPersonApiClient = useAuthenticatedApiClient(KeyPersonApiClient);

  useEffect(() => {
    getKeyPeople();
  }, [financialApplicationId]);

  const getKeyPeople = async () => {
    setIsLoading(true);
    try {
      const people = await keyPersonApiClient.getKeyPeople(financialApplicationId);
      setKeyPeople(people);
    } catch (error) {
      console.error(error);
      AppToasterV2.showFailedActionToaster("Failed to get key people.");
    } finally {
      setIsLoading(false);
    }
  };

  return {
    keyPeople,
    isLoading,
    getKeyPeople,
  };
};
